export const gamesQueryKey = { all: ['games'] as const };

// Session-scoped: the signed-in user's own profile and Grants, not tied to a game.
export const meQueryKey = { all: ['me'] as const };

// The directory: global, since a user's Grants span Games.
export const usersQueryKey = {
  all: ['users'] as const,
  detail: (userId: number) => [...usersQueryKey.all, userId] as const,
};

export const sandboxQueryKey = {
  current: ['sandbox'] as const, // the sandbox's own detail/state (unscoped); content is scoped under [gameCode, sandboxCode]
  detail: (id: string) => [...sandboxQueryKey.current, id],
  // scope leads: [gameCode, ...] so invalidating a game prunes its sandbox list
  list: (gameCode: string) => [gameCode, 'sandboxes'] as const,
};
